import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BhAuthService {

  initialiseAuth(dataCentre: string) {
    if (!dataCentre) {
      dataCentre = 'auth';
    }

    console.log(`Redirecting to bullhorn auth for datacentre ${dataCentre}`);

    window.location.href = this.buildAuthorizeUrl(dataCentre);
    return false;
  }

  private buildAuthorizeUrl(dataCentre: string): string {
    const bhHost = this.bhHostFromDataCentre(dataCentre);

    const clientId = `client_id=${environment.clientId}`;
    const typeCode = `response_type=code`;
    const state = `state=1`;
    const redirectUrl = `${environment.kyloeAuthHost}?callback=${BhAuthService.createTokenUrl(dataCentre)}`;
    const encodedRedirect = `redirect_uri=${redirectUrl}`;
    return `${bhHost}?${clientId}&${typeCode}&${state}&${encodedRedirect}`;
  }

  private static createTokenUrl(dataCentre: string): String {
    let tokenUrl: String = `${window.location.protocol}//${window.location.hostname}`;
    if (window.location.port) {
      tokenUrl += `:${window.location.port}`;
    }
    sessionStorage.setItem(`authPostRedirectUrl`, window.location.pathname);
    tokenUrl += `/token/${dataCentre.toLowerCase()}?token=`;
    return tokenUrl;
  }

  private bhHostFromDataCentre(dataCentre: string): string {
    switch (dataCentre) {
      case 'east'        : return 'https://auth-east.bullhornstaffing.com/oauth/authorize';
      case 'west'        : return 'https://auth-west.bullhornstaffing.com/oauth/authorize';
      case 'west_50'     : return 'https://auth-west50.bullhornstaffing.com/oauth/authorize';
      case 'apac'        : return 'https://auth-apac.bullhornstaffing.com/oauth/authorize';
      case 'aus'         : return 'https://auth-aus.bullhornstaffing.com/oauth/authorize';
      case 'sydney'      : return 'https://auth-syd.bullhornstaffing.com/oauth/authorize';
      case 'emea'        : return 'https://auth-emea.bullhornstaffing.com/oauth/authorize';
      case 'germany'     : return 'https://auth-ger.bullhornstaffing.com/oauth/authorize';
      case 'frankfurt'   : return 'https://auth-frk.bullhornstaffing.com/oauth/authorize';
      case 'france'      : return 'https://auth-fra.bullhornstaffing.com/oauth/authorize';
      case 'staging_west': return 'https://auth-west9.bullhornstaffing.com/oauth/authorize';
      case 'staging_emea': return 'https://auth-emea9.bullhornstaffing.com/oauth/authorize';
      case 'staging'     : return 'https://auth9.bullhornstaffing.com/oauth/authorize';
      default            : return 'https://auth.bullhornstaffing.com/oauth/authorize';
    }
  }
}
